import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ButtonGroup } from '@atlaskit/button';
import Button from '@atlaskit/button/standard-button';
import { PrimaryCTA } from '@atlassian/amkt-common';
import React, { Component } from 'react';
export default class ConfirmCancelFooter extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(PrimaryCTA, {
      testId: this.props.testId,
      href: this.props.href,
      isDisabled: this.props.isPrimaryDisabled,
      onClick: this.props.onPrimaryCTAClick,
      isLoading: this.props.isLoading
    }, this.props.primaryCTALabel), /*#__PURE__*/React.createElement(Button, {
      appearance: "subtle-link",
      onClick: this.props.onClose
    }, "Cancel")));
  }

}